export function Card({ ...props }) {
  return (
    <div className="custom-card">
      <img src={props.imgSrc} alt={props.imgAlt} />
      <h3 className='header-font custom-card__heading'>{props.heading}</h3>
      {props.children}
    </div>
  )
}